import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import { getErrorMessage } from 'helpers/errors';
import { getSpecialtyModule } from 'features/contents/contentsAPI';
import ContentNav from './ContentNav';

export default function SpecialtyModules() {
  const [showAlert, message, alert] = useAlert(false, '');
  const [content, setContent] = useState('');

  useEffect(() => {
    getSpecialtyModule()
      .then(data => {
        if (data) {
          setContent(data.content);
        }
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudieron obtener los módulos');
      });
  }, []);

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>
                  Desc. Módulos de Especialidad
                </Col>
                <Col md={4} className="text-right">
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <ContentNav />
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {/* Admin-managed HTML content from database, safe to render */}
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
